import React, { ComponentType, ReactNode } from 'react'
import { WithShowIfProps } from './with-show-if.props'

export const withShowIf = <P extends object>(
  Component: ComponentType<P>,
  defaultReactNode?: ReactNode,
) => {
  const defaultToShow = defaultReactNode || null
  return class WithShowIf extends React.Component<P & WithShowIfProps> {
    public render() {
      const { showIf, ...rest } = this.props
      return showIf !== false ? <Component {...(rest as P)} /> : defaultToShow
    }
  }
}
